export default {
  productAttribute: {
    AttributeName: '属性名称',
    AttributeCode: '属性编号',
    AttributeValueCode: '属性值编号',
    AttributeValueName: '属性值名称',
    AttributeDetails: '属性详情',
    PleaseEnterAttributeName: '请输入属性名称',
    PleaseEnterAttributeCode: '请输入属性编号',
    PleaseAddProductAttribute: '请添加商品属性'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/pmc/productAttribute.js